import React from 'react';
import OfferCreateEditForm from './Form/OfferForm';
import { Edit } from 'react-admin';
export const OfferShow = (props) => (
  <Edit {...props} hasShow={false}>
    <OfferCreateEditForm
      //  permissions={permissions}
      disabledField={true}
      redirect='list'
      name='Show Offer'
      allowEmpty
    />
  </Edit>
);
